import styled from 'styled-components';

const SponsoredProductBeacon = styled.img`
  .resultGrid .product &,
  .resultList .product .sponsored & {
    position: absolute;
    top: 0;
    left: 0;
  }
`;

export default SponsoredProductBeacon;
